/* Fixed display order for HSOC tiers. Only tiers present in the response are
 * rendered, in this order. */
const HSOC_TIER_ORDER = ['FREE', 'STARTER', 'PROFESSIONAL', 'ENTERPRISE'];

/* The subset of the tier option this mapper reads today. Widen as more of the
 * card (price, ctas, badge) gets mapped in follow-up work (TODO(#21690)). */

/*
 * Maps the HSOC V2 productsByTier response into the merch card grid's card
 * props. For now this only maps the per-tier feature list — price, CTAs,
 * badge, title, and subheading are intentionally left as placeholders and
 * will be filled in follow-up work (TODO(#21690)).
 */
export function mapProductsByTierToCards(productsByTier) {
  if (!productsByTier) {
    return [];
  }
  return HSOC_TIER_ORDER.filter(tierName => tierName in productsByTier).map(tierName => {
    const tierOption = productsByTier[tierName];
    return {
      tierApiName: tierOption.productApiName,
      tierName,
      /* TODO(#21690): map price/ctas/badge. */
      /* feature.name is a display string returned by the API, not an i18n
       * key — it must not be wrapped in I18n.text(). */
      features: tierOption.featuresForTier.map(feature => ({
        key: feature.name,
        label: feature.name,
        isAvailable: true
      })),
      ctas: []
    };
  });
}